import { createSelector } from 'reselect';

import type { IAgronomyAgreementCrop, IAgronomyAgreementCropsState } from './types';

export const selectCrops = createSelector(
  (state: IAgronomyAgreementCropsState) => state.crops,
  (crops) => [...crops].sort((a, b) => a.cropTitle.localeCompare(b.cropTitle)),
);

export const selectIndexedCrops = createSelector(selectCrops, (crops) =>
  crops.reduce<Record<string, IAgronomyAgreementCrop | undefined>>((indexed, crop) => {
    if (crop.cropRef) {
      indexed[crop.cropRef] = crop;
    }
    return indexed;
  }, {}),
);

export const selectCrop = createSelector(
  [selectIndexedCrops, (_: IAgronomyAgreementCropsState, cropRef: string) => cropRef],
  (indexedCrops, cropRef) => indexedCrops[cropRef],
);
